import React, { useState } from 'react';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import _get from 'lodash-es/get';
import Tooltip from 'sushiweb/Tooltip/Tooltip';
import Button from 'sushiweb/Button';

import {
  FORCESERVER,
  ONLINE,
  creditTransactionsStatusEnum,
  currentFlowTypeEnum,
  cycleTypeEnum,
  entityTypeEnum,
  eventsAmountEnum,
  gcProgramStatusEnum,
  invoicesStatusEnum,
  orderInvoicesZipFileName,
  paymentRequestEnum,
  paymentRequestStatus,
  sourceToCreditType,
  statusLabels,
  topupsStatusEnum,
  weekDays,
  wrongFormat,
} from '../pages/common/components/constants';
import { enumSlots, slotType } from '../pages/WalletPrograms/constants';
import { FormatTimeWrapper } from '../pages/common/styles';
import OnlinePaymentModal from '../pages/common/components/OnlinePaymentModal';
import {
  InvoiceOnlineContainer,
  StatusContainer,
} from '../pages/common/components/DataTables/styles';
import {
  DAY,
  MONTH,
  WEEK,
} from '../pages/WalletPrograms/CreateProgramModal/ProgramForms/common/Components/constants';
import {
  ENTERPRISE_BALANCE_SERVICE_TYPE,
  ENTERPRISE_GC_SERVICE_TYPE,
  ENTERPRISE_LIMIT_SERVICE_TYPE,
  INTERNAL_TESTING_SERVICE_TYPE,
} from '../pages/Payments/OnlinePaymentCheckoutPage/PaymentKit/Constants';
// import { TableClickButton } from '../pages/WalletPrograms/styles';
import { HOST } from '../constants/urls';
import { billQuestionKey, MULTI_OFFICES_EMP_ROWS } from '../constants';

export const initialiseLoginSDKs = () => {
  const script = document.createElement('script');
  script.src = process.env.REACT_APP_AUTH_SDK_URL;
  script.async = true;
  document.body.appendChild(script);
  script.onload = () => {
    if (window.zoauth !== undefined) {
      window.zoauth
        .init(process.env.REACT_APP_AUTH_CLIENT_ID, '', 'offline', {
          LOGIN_METHODS: ['email', 'google'],
          // THEME: 'CF_INVITE_THEME',
        })
        .then(success => {
          console.log(success);
        });
    }
  };
};

export const isUserLoggedIn = data => {
  let numericUserId = Number(_get(data, 'user_id', 0));
  numericUserId = Number.isNaN(numericUserId) ? 0 : numericUserId;
  const name = _get(data, 'name', '');
  // const email = _get(data, 'email', '');
  return Boolean(numericUserId && name);
};

export const arrayToObject = (arr, keyField) =>
  Object.assign({}, ...arr.map(item => ({ [item[keyField]]: item })));

export const copyrightLabel = () => {
  const year = new Date().getFullYear();
  return `© 2008-${year} - Zomato™ Pvt Ltd.`;
};

export const displayDateFormat = str => {
  const completeDate = new Date(str);
  const currentDate = str.split(' ')[0];
  const [date, month] = currentDate.split('-');
  const fullYear = `${completeDate.getFullYear()}`;
  const newYear = fullYear.substring(2);
  return [date, month, newYear].join('-');
};

export const formatDate = date => {
  const currentDate = new Date(date);
  let month = `${currentDate.getMonth() + 1}`;
  let day = `${currentDate.getDate()}`;
  const year = `${currentDate.getFullYear()}`;

  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;

  return [year, month, day].join('-');
};

export const processDate = date => {
  const dateParts = date.split('-');
  return new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
};

export const dateStringFormat = date => {
  return date
    .split(' ')[0]
    .split('-')
    .join(' ');
};

export const formatMonth = date => {
  const currentDate = new Date(date);
  let month = `${currentDate.getMonth() + 1}`;
  const year = `${currentDate.getFullYear()}`;

  if (month.length < 2) month = `0${month}`;

  return [year, month].join('-');
};

export const formatTime = data => {
  return (
    <FormatTimeWrapper>
      <p>{data.split(' ')[0]}</p>
      <p>{data.split(' ')[1] ? data.split(' ')[1] : null}</p>
    </FormatTimeWrapper>
  );
};
export const newFormatTime = data => {
  return (
    <>
      {data.split(' ')[0]}
      {data.split(' ')[1] ? ` | ` : null}
      {data.split(' ')[1]}
    </>
  );
};
export const formatDateWithoutTime = data => {
  return <>{data.split(' ')[0]}</>;
};
export const ISOtoLongDate = data => {
  const d = new Date(data.split(' '));
  return d.toDateString().split('');
};

export const getMonthAndYearFromDate = (date, withComma) => {
  if (!date || date === undefined) {
    return ' ';
  }
  const d = new Date(date.split(' ')[0]);
  const month = d.toLocaleString('default', {
    month: 'short',
  });
  const year = d.getFullYear();
  if (withComma) {
    return `${month}, ${year}`;
  }
  return `${month} ${year}`;
};

export const isCurrentMonth = date => {
  if (!date || date === undefined) {
    return false;
  }
  const d = new Date(date.split(' ')[0]);
  const currentDate = new Date();
  return (
    d.getMonth() === currentDate.getMonth() &&
    d.getFullYear() === currentDate.getFullYear()
  );
};

export const isInvoiceGenerated = status => {
  return (
    status === invoicesStatusEnum.GENERATED_UNPAID ||
    status === invoicesStatusEnum.PAYMENT_PENDING ||
    status === invoicesStatusEnum.PARTIALLY_PAID ||
    status === invoicesStatusEnum.PAID ||
    status === invoicesStatusEnum.SETTLED_PAID
  );
};

export const getPeriodForInvoice = date => {
  if (!date || date === undefined) {
    return ' ';
  }
  const currentDate = new Date();

  if (!isCurrentMonth(date)) {
    return getMonthAndYearFromDate(date, true);
  }

  const day = String(currentDate.getDate()).padStart(2, '0');
  const month = currentDate.toLocaleString('default', {
    month: 'short',
  });
  const year = currentDate.getFullYear();

  return `Till ${day}-${month}, ${year}`;
};

export const getServiceTypeFromFlowType = flowType => {
  switch (flowType) {
    case currentFlowTypeEnum.FLOW_TYPE_PPI:
      return ENTERPRISE_BALANCE_SERVICE_TYPE;
    case currentFlowTypeEnum.FLOW_TYPE_LIMIT:
      return ENTERPRISE_LIMIT_SERVICE_TYPE;
    case currentFlowTypeEnum.FLOW_TYPE_GIFT_CARD:
      return ENTERPRISE_GC_SERVICE_TYPE;
    default:
      return INTERNAL_TESTING_SERVICE_TYPE;
  }
};

export const formatDateinLocalFormat = d => {
  const MMM = d.toLocaleString('default', {
    month: 'short',
  });
  const year = d.toLocaleString('default', {
    year: '2-digit',
  });
  return `${d.getDate()}-${MMM}-${year}`;
};

export const formatDateinDDMMMYYY = data => {
  const d = new Date(data.split(' ')[0]);
  const MMM = d.toLocaleString('default', {
    month: 'short',
  });
  const year = d.toLocaleString('default', {
    year: 'numeric',
  });
  return `${d.getDate()}-${MMM}-${year}`;
};

export const formatDateInDateOrdinalFormat = date => {
  const d = new Date(date.split(' ')[0]);
  const MMM = d.toLocaleString('default', {
    month: 'short',
  });
  return `${d.getDate()}${getOrdinal(d.getDate())} ${MMM} ${d.getFullYear()}`;
};

export const getTimeFromDate = date => {
  const dateSplit = date.split(' ');
  if (dateSplit.length < 2) return ' ';
  if (dateSplit[1].length < 8) {
    return dateSplit[1];
  }
  return dateSplit[1].substring(0, 8);
};

export const convertTo12HourFormat = time24 => {
  // Split the time into hours and minutes
  const splitTime = time24.split(':');
  let hours = parseInt(splitTime[0], 10);
  const minutes = splitTime[1];

  // Determine whether it's AM or PM
  const period = hours < 12 ? 'AM' : 'PM';

  // Adjust hours to 12-hour format
  hours = hours % 12 || 12;

  return `${hours}:${minutes} ${period}`;
};

export const formatDateinDDMMMYYYAndTime = date => {
  const dateArr = date.split(' ');
  if (dateArr.length === 0) {
    return ' ';
  }
  const d = new Date(dateArr[0]);
  const formattedDate = formatDateinLocalFormat(d);
  if (dateArr.length === 1) {
    return formattedDate;
  }
  const formattedTime = convertTo12HourFormat(dateArr[1]);
  return `${formattedDate} | ${formattedTime} `;
};

export const formatDateinDDMMMYYYAndTimeWithoutSeparator = date => {
  const dateArr = date.split(' ');
  if (dateArr.length === 0) {
    return ' ';
  }
  const formattedDate = formatDateinDDMMMYYY(date);
  if (dateArr.length === 1) {
    return formattedDate;
  }
  const formattedTime = convertTo12HourFormat(dateArr[1]);
  return `${formattedDate} ${formattedTime} `;
};

export const formatDateTime = date => {
  return `${formatDateinDDMMMYYY(date)} ${getTimeFromDate(date)}`;
};
export const formatDateForInfoSections = data => {
  const d = new Date(data.split(' ')[0]);
  const MMM = d.toLocaleString('default', {
    month: 'short',
  });
  return `${d.getDate()} ${MMM}, ${d.getFullYear()}`;
};
export const ISOtoLongDateTime = data => {
  const d = new Date(data);
  return d.toDateString();
};
export const getDailyAmount = slots => {
  let totalAmount = 0;
  slots.forEach(slot => {
    const slotAmount = slot?.amount && slot?.amount !== '' ? slot?.amount : '0';
    totalAmount += parseFloat(slotAmount);
  });
  return totalAmount;
};
export const getEmployeesCountFromGroups = groups => {
  let employeesCount = 0;
  groups.forEach(group => {
    employeesCount += group.active_employees;
  });
  return employeesCount;
};
export const getFormattedEndDate = endDate => {
  const currentDate = new Date(endDate);
  const year = `${currentDate.getFullYear()}`;
  // we get date as 01/01/3000 in never ends case
  if (year === '3000') return 'NA';
  return endDate;
};
export const validateName = name => {
  const re = /^[a-zA-Z0-9 ()@-]+$/;
  return re.test(String(name).toLowerCase());
};

export const validateEmployeeName = name => {
  const re = /^[A-Za-z0-9? ,_-]+$/;
  return re.test(String(name));
};

export const commaCsvChecks = data => {
  const re = /[;,]/g;
  return re.test(data);
};

export const getCurrentDate = () => {
  const currentDate = new Date();
  return currentDate
    .toLocaleDateString()
    .split('/')
    .join('-');
};

export const getTimeIn12HRFormat = time => {
  let formattedTime = time
    .toString()
    .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

  if (formattedTime.length > 1) {
    formattedTime = formattedTime.slice(1);
    formattedTime[5] = +formattedTime[0] < 12 ? ' AM' : ' PM';
    formattedTime[0] = +formattedTime[0] % 12 || 12;
  }
  return formattedTime.join('');
};

const DAY_ORDER = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

export const formatDays = (days = []) => {
  if (!days.length) return 'NA';
  if (days.length === 7) return 'All days';

  const sortedDays = [...days].sort((a, b) => DAY_ORDER.indexOf(a) - DAY_ORDER.indexOf(b));
  return sortedDays.join(', ');
};

export const formatPlanDateTime = (date, { time, neverEnds } = {}) => {
  if (neverEnds) return 'Never ends';
  if (!date) return 'NA';
  try {
    const formattedDate = formatDateinDDMMMYYY(date);
    if (!time) return formattedDate;
    const formattedTime = getTimeIn12HRFormat(time);
    return `${formattedDate}, ${formattedTime}`;
  } catch {
    return date;
  }
};

export const slotTimeValidation = slots => {
  for (let i = 0; i < slots.length; i += 1) {
    const slot = slots[i];
    if (slot.startTime < enumSlots[slotType[slot.type]].startTime) {
      return false;
    }
    if (slot.endTime > enumSlots[slotType[slot.type]].endTime) {
      return false;
    }
    if (slot.startTime > slot.endTime) {
      return false;
    }
  }
  return true;
};

export const getSlotDetails = slotsArray => {
  const updatedArray = [];
  slotsArray.forEach(value => {
    const slotValue = {
      startTime: value.start_time ?? '',
      endTime: value.end_time ?? '',
      amount: value.amount ?? 0,
      type: value.type ?? 1,
    };
    updatedArray.push(slotValue);
  });
  return updatedArray;
};

export const roundOffTwoDecimals = val => {
  return Math.round(val * 100) / 100;
};

export const formatAmountInRupees = val => {
  if (typeof val === 'string' || val instanceof String) {
    return `₹${val}`;
  }
  const roundedVal = Math.round(val * 100) / 100;
  return `₹${roundedVal.toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

export const getPaymentRequestLogStatusMessage = (status, flowType) => {
  switch (status) {
    case paymentRequestEnum.EXPIRED:
      return `Payment Link is expired. Please contact ${flowType === currentFlowTypeEnum.FLOW_TYPE_GIFT_CARD
        ? 'giftcardsales@zomato.com'
        : 'POC'
        } to re-send payment link`;
    case paymentRequestEnum.INACTIVE:
      return `Payment Link is not active. Please contact ${flowType === currentFlowTypeEnum.FLOW_TYPE_GIFT_CARD
        ? 'giftcardsales@zomato.com'
        : 'POC'
        } to re-send payment link`;
    case paymentRequestEnum.PAID:
      return 'Payment has been successfully made';
    default:
      return '';
  }
};

export const getStatusForInvoice = invoice => {
  if (invoice.status === invoicesStatusEnum.PAYMENT_PENDING) {
    return (
      <Tooltip
        position='bottom'
        label={`${formatAmountInRupees(
          invoice.amount_to_be_approved ?? 0,
        )} transferred via bank is pending for approval`}
        appearance='light'
        size='big'
        style={{
          fontSize: '12px',
          maxWidth: '180px',
        }}
      >
        <StatusContainer status={invoicesStatusEnum[invoice.status]}>
          {statusLabels[invoicesStatusEnum[invoice.status]]}
        </StatusContainer>
      </Tooltip>
    );
  }
  return (
    <StatusContainer status={invoicesStatusEnum[invoice.status]}>
      {statusLabels[invoicesStatusEnum[invoice.status]]}
    </StatusContainer>
  );
};

// Temporary
export const getAmountApprovalPendingForInvoice = invoice => {
  const amountApprovalPending =
    invoice.payable_amount - invoice.paid_amount - invoice.pending_amount;
  if (amountApprovalPending === 0) {
    return ' - ';
  }
  return formatAmountInRupees(Math.max(0, amountApprovalPending));
};

export const formatEventsAmountValue = (event, amountState, toBeDownloaded) => {
  const isEventTerminated =
    event.status === topupsStatusEnum.TOPUP_EXPIRED_SUCCESS ||
    event.status === topupsStatusEnum.COMPLETED_SUCCESS ||
    event.status === topupsStatusEnum.DELETED_SUCCESS ||
    event.status === topupsStatusEnum.PAUSED_SUCCESS;

  let amountVal = event.total_amount.value - event.disbursed_amount.value;
  if (toBeDownloaded) amountVal = String(amountVal);

  if (
    (isEventTerminated && amountState === eventsAmountEnum.RELEASED) ||
    (!isEventTerminated && amountState === eventsAmountEnum.PENDING)
  ) {
    return formatAmountInRupees(amountVal);
  }
  return formatAmountInRupees(0);
};

export const formatReferenceIDForPayments = data => {
  if (data.reference_id === '') {
    return ' - ';
  }
  if (sourceToCreditType(data.source) === ONLINE) {
    return data.reference_id;
  }
  return maskUptoLastNDigits(data.reference_id, 14);
};

export const formatIDForGifting = data => {
  if (data === '') {
    return ' - ';
  }
  return maskUptoLastNDigits(data, 6)?.toUpperCase();
};

export const formatPOIForProgram = POIAddress => {
  const POIAddArray = POIAddress.split(',');
  let formattedPOI = '';
  if (POIAddArray.length !== 0) {
    formattedPOI = `${POIAddArray[0]}`;
    if (
      POIAddArray.length >= 2 &&
      POIAddArray[0].length + POIAddArray[1].length <= 30
    ) {
      formattedPOI = `${POIAddArray[0]}, ${POIAddArray[1]}`;
    }
  }
  return formattedPOI;
};

export const checkAmountInEachSlotWithBudget = (slots, budget) => {
  for (let i = 0; i < slots.length; i += 1) {
    if (parseInt(slots[i].amount, Number) > parseInt(budget, Number))
      return false;
  }
  return true;
};
export const amountBlockedForTopup = row => {
  if (
    topupsStatusEnum[row.status] === 'SCHEDULED_FUNDSBLOCKED' ||
    topupsStatusEnum[row.status] === 'PROCESSING' ||
    topupsStatusEnum[row.status] === 'PARTIALLY_EXECUTED'
  ) {
    return formatAmountInRupees(
      row.total_amount.value - row.disbursed_amount.value,
    );
  }
  return ' - ';
};

export const checkValidDate = dateStr => {
  const date = new Date(dateStr);
  return date.toString() !== 'Invalid Date' && date.getFullYear() !== 2001;
};

export const checkFileTypeSize = file => {
  return new Promise((resolve, reject) => {
    const ext = file.name.match(/\.[0-9a-z]+$/i)[0];
    const validateType = ['.csv'].includes(ext);
    const validateSize = file.size <= 5242880;

    if (file) {
      resolve(validateType && validateSize);
    } else {
      const noFileErr = new Error(wrongFormat);
      reject(noFileErr);
    }
  });
};

export const clearInputValue = () => {
  document.getElementById('upload-file').value = '';
};

export const currenyFormatter = amount => {
  const formatter = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    symbol: '₹',
    currency: 'INR',
  });

  return formatter.format(amount);
};

export const searchWithName = (arr = [], searchTerm = '', keyFields = []) => {
  let searchResults = arr;
  if (searchTerm && keyFields.length !== 0 && arr.length !== 0) {
    searchResults = arr.filter(obj => {
      return keyFields.find(keyField => {
        let value = obj[keyField];
        if (value) {
          if (/^\d{4}-\d{2}-\d{2}$/.test(value)) {
            value = formatDateinDDMMMYYY(value);
          }
          if (
            String(value)
              .toLowerCase()
              .includes(searchTerm.trim().toLowerCase())
          )
            return obj;
        }
        return null;
      });
    });
  }
  return searchResults;
};

export const prependZero = v => {
  if (v <= 9) {
    return `0${v}`;
  }
  return `${v}`;
};

const csvMultiOfficesEmpContent = `data:text/csv;charset=utf-8,${MULTI_OFFICES_EMP_ROWS.map(
  e => e.join(','),
).join('\n')}`;

export const downloadMultiOfficesCSV = () => {
  const encodedUri = encodeURI(csvMultiOfficesEmpContent);
  const link = document.createElement('a');
  link.setAttribute('href', encodedUri);
  link.setAttribute('download', 'sample_employee_data.csv');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const empRows = [
  ['emailId', 'employeeName', 'contact'],
  ['rishabh@zomato.com', 'Rishabh', '9999999999'],
  ['achin@zomato.com', 'Achin', '9999999999'],
];

const csvEmpContent = `data:text/csv;charset=utf-8,${empRows
  .map(e => e.join(','))
  .join('\n')}`;

const encodedEmpUri = encodeURI(csvEmpContent);
const Emplink = document.createElement('a');
Emplink.setAttribute('href', encodedEmpUri);
Emplink.setAttribute('download', 'sample_employee_data.csv');
document.body.appendChild(Emplink);

export const downloadCSV = () => Emplink.click();

const groupRows = [
  ['emailId'],
  ['rahul@zomato.com'],
  ['pooja@zomato.com'],
  ['neha@zomato.com'],
];

const csvGroupContent = `data:text/csv;charset=utf-8,${groupRows
  .map(e => e.join(','))
  .join('\n')}`;

const encodedGrpUri = encodeURI(csvGroupContent);
const Grplink = document.createElement('a');
Grplink.setAttribute('href', encodedGrpUri);
Grplink.setAttribute('download', 'sample_team_data.csv');
document.body.appendChild(Grplink);

export const downloadGroupCSV = () => Grplink.click();

const formatCSVItemValue = value => {
  if (value === undefined) {
    return ' - ';
  }
  if (
    (typeof value === 'string' || value instanceof String) &&
    value.includes(',')
  )
    return ' - ';
  return value;
};

export const convertArrayOfObjectsToCSV = (array, headKeys, headValues) => {
  let result;

  const columnDelimiter = ',';
  const lineDelimiter = '\n';
  const keys = array.length ? headKeys : [];

  result = '';
  result += headValues.join(columnDelimiter);
  result += lineDelimiter;

  array.forEach(item => {
    let ctr = 0;
    keys.forEach(key => {
      if (ctr > 0) result += columnDelimiter;

      result += formatCSVItemValue(item[key]);
      ctr += 1;
    });
    result += lineDelimiter;
  });

  return result;
};

export const exportCSV = (dataArray, tableName, headColumns) => {
  const link = document.createElement('a');
  const headKeys = headColumns.map(col => col.key);
  const headValues = headColumns.map(col => col.value);
  let csv = convertArrayOfObjectsToCSV(dataArray, headKeys, headValues);
  if (csv == null) return;

  const filename = `${tableName}.csv`;

  if (!csv.match(/^data:text\/csv/i)) {
    csv = `data:text/csv;charset=utf-8,${csv}`;
  }

  link.setAttribute('href', encodeURI(csv));
  link.setAttribute('download', filename);
  link.click();
};

export const maskUptoLastNDigits = (text, N) => {
  if (text?.length < N) {
    return text;
  }
  return `${text?.substring(text.length - N)}`;
};

export const maskUptoFirstNDigits = (text, N) => {
  return `${text.substring(0, N)}`;
};

export const truncateUptoNDigits = (text, N) => {
  if (text.length < N) {
    return text;
  }
  return `${text.substring(0, N)}...`;
};

export const checkValidExecutionDate = dateStr => {
  const date = new Date(dateStr);
  // we gate execution date as 0001-01-01 when the date is invalid
  return date.getFullYear() !== 2001;
};

export const includesOption = (filters, option) => {
  for (let i = 0; i < filters.length; i += 1) {
    for (let j = 0; j < option.value.length; j += 1) {
      if (filters[i].value[j] === option.value[j]) {
        return true;
      }
    }
  }
  return false;
};
export const indexOfOption = (filters, option) => {
  for (let i = 0; i < filters.length; i += 1) {
    for (let j = 0; j < option.value.length; j += 1) {
      if (filters[i].value[j] === option.value[j]) {
        return i;
      }
    }
  }
  return -1;
};

export const getOrdinal = n => {
  let ord = 'th';
  if (n % 10 === 1 && n % 100 !== 11) {
    ord = 'st';
  } else if (n % 10 === 2 && n % 100 !== 12) {
    ord = 'nd';
  } else if (n % 10 === 3 && n % 100 !== 13) {
    ord = 'rd';
  }
  return ord;
};

export const dateSortableFormat = dateStr => {
  const date = new Date(dateStr);
  return date;
};

export const formatDateSorting = dateStr => {
  if (dateStr === null || dateStr === undefined) {
    return ' ';
  }
  const dateVal = dateStr.split('.')[0];
  return new Date(dateVal);
};

export const actionBtnListTopMargin = val => {
  switch (val) {
    case 1:
      return '0px';
    case 2:
      return '-10px';
    case 3:
      return '30px';
    default:
      return '0px';
  }
};

export const queryVariableValue = variable => {
  const hrefArr = window.location.href.split('?');
  if (hrefArr.length <= 1) {
    return [false, ''];
  }
  const vars = hrefArr[1].split('&');
  for (let i = 0; i < vars.length; i += 1) {
    const pair = vars[i].split('=');
    if (pair[0] === variable) {
      return [true, pair[1]];
    }
  }
  return [false, ''];
};

// TODO: need to remove this check when we add a switch
export const checkIfLimitFlowPresent = applicableFlows => {
  for (let i = 0; i < applicableFlows.length; i += 1)
    if (applicableFlows[i] === currentFlowTypeEnum.FLOW_TYPE_LIMIT) {
      return true;
    }
  return false;
};

export const getAvailableWorkspaceLimit = workspace => {
  const prepaidLimit = workspace?.prepaid_limit ?? 0;
  const creditLimit = workspace?.credit_limit ?? 0;
  const usedLimit = workspace?.used_limit ?? 0;
  return formatAmountInRupees(prepaidLimit + creditLimit - usedLimit);
};

export const getCycleAmount = plan => {
  switch (plan.cycle_type) {
    case cycleTypeEnum.WEEKLY:
      return `${formatAmountInRupees(plan.weekly_amount)}/week`;
    case cycleTypeEnum.MONTHLY:
      return `${formatAmountInRupees(plan.monthly_amount)}/month`;
    case cycleTypeEnum.DAILY:
      return `${formatAmountInRupees(plan.daily_amount)}/day`;
    default:
      return `₹0`;
  }
};

export const getCycleAmountForCSV = plan => {
  switch (plan.cycle_type) {
    case cycleTypeEnum.WEEKLY:
      return `${plan.weekly_amount}/week`;
    case cycleTypeEnum.MONTHLY:
      return `${plan.monthly_amount}/month`;
    case cycleTypeEnum.DAILY:
      return `${plan.daily_amount}/day`;
    default:
      return `₹0`;
  }
};

export const convertStringToInteger = str => {
  const num = parseInt(str, 10);
  if (Number.isNaN(num)) {
    return 0;
  }
  return num;
};

export const isValidPaymentRequest = paymentRequest => {
  if (
    paymentRequest?.payment_request_id === undefined ||
    paymentRequest?.payment_request_id === ''
  )
    return false;
  return true;
};

export const isProgramEnded = program => {
  const endDate = new Date(program.end_date);
  endDate.setHours(23, 59, 59, 999);
  const currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);
  return endDate < currentDate;
};

export const employeeCountForAdhocPrograms = adhocProg => {
  const paymentReqDetails = adhocProg?.payment_request;
  const amount = adhocProg?.amount;
  if (isValidPaymentRequest(paymentReqDetails) && amount) {
    return Number((paymentReqDetails?.amount ?? 0) / amount);
  }
  return ' - ';
};

export const totalAmountForAdhocProgram = adhocProg => {
  if (isValidPaymentRequest(adhocProg?.payment_request)) {
    return formatAmountInRupees(adhocProg?.payment_request?.amount ?? 0);
  }
  return ' - ';
};

export const paymentLinkForAdhocPrograms = adhocProg => {
  const paymentReqDetails = adhocProg?.payment_request;
  if (isValidPaymentRequest(paymentReqDetails)) {
    if (paymentReqDetails?.status === paymentRequestStatus.ACTIVE_PENDING) {
      return (
        <a
          href={`${HOST}/online-payment/${paymentReqDetails?.payment_request_id ??
            ''}`}
          target='_blank'
          rel='noreferrer'
        >
          {' '}
          <Button size='small' appearance='primary'>
            Pay
          </Button>
        </a>
      );
    }
  }
  return ' - ';
};

export const statusForAdhocPrograms = adhocProg => {
  const programStatus = adhocProg?.program_status;
  const paymentReqDetails = adhocProg?.payment_request;
  if (
    programStatus === gcProgramStatusEnum.GC_DRAFTED ||
    programStatus === gcProgramStatusEnum.GC_DELETED ||
    programStatus === gcProgramStatusEnum.GC_NOT_STARTED ||
    programStatus === gcProgramStatusEnum.GC_COMPLETED_ENDED
  ) {
    const status = gcProgramStatusEnum[programStatus] ?? 'default';
    return (
      <StatusContainer status={status}>{statusLabels[status]}</StatusContainer>
    );
  }
  if (
    isProgramEnded(adhocProg) &&
    paymentReqDetails?.status !== paymentRequestEnum.PAID
  ) {
    const status = 'EXPIRED';
    return (
      <StatusContainer status={status}>{statusLabels[status]}</StatusContainer>
    );
  }
  if (isValidPaymentRequest(paymentReqDetails)) {
    const status = paymentRequestStatus[paymentReqDetails?.status ?? 0];
    return (
      <StatusContainer status={status}>{statusLabels[status]}</StatusContainer>
    );
  }
  return ' - ';
};

export const replaceSpecialCharacters = str => {
  const regex = /[!@#$%^&*()+=[\]{};:'"<>,.?|\\`~]/g;
  const result = str.replace(regex, '');

  return result;
};

export const formatCreditTransactionActualTopupDate = data => {
  if (
    data.updated_on === '' ||
    data.status !== creditTransactionsStatusEnum.TRANSACTION_SUCCESS
  ) {
    return ' - ';
  }
  return formatDateinDDMMMYYYAndTime(data.updated_on);
};

export const getCycleFrequency = plan => {
  switch (plan.cycle_type) {
    case cycleTypeEnum.WEEKLY:
      return `Every ${weekDays[new Date(plan.start_date.replace(' IST', '')).getDay()]
        }`;
    case cycleTypeEnum.MONTHLY:
      return `${new Date(
        plan.start_date.replace(' IST', ''),
      ).getDate()}${getOrdinal(
        new Date(plan.start_date.replace(' IST', '')).getDate(),
      )} ${'of every month'}`;
    case cycleTypeEnum.DAILY:
      return `Everyday`;
    default:
      return ` - `;
  }
};

export const getReviewProgramCycleAmount = (
  cycleType,
  amountWeekly,
  amountMonthly,
  amountDaily,
) => {
  switch (cycleType) {
    case cycleTypeEnum.WEEKLY:
      return `${formatAmountInRupees(amountWeekly)}/week`;
    case cycleTypeEnum.MONTHLY:
      return `${formatAmountInRupees(amountMonthly)}/month`;
    case cycleTypeEnum.DAILY:
      return `${formatAmountInRupees(amountDaily)}/day`;
    default:
      return ` - `;
  }
};

export const getReviewProgramTopUpInfo = (startDate, cycleType) => {
  const monthlyStartDate = new Date(startDate.replace(' IST', '')).getDate();
  const ordinalForStartDate = getOrdinal(monthlyStartDate);
  const weeklyStartDay =
    weekDays[new Date(startDate.replace(' IST', '')).getDay()];
  switch (cycleType) {
    case cycleTypeEnum.WEEKLY:
      return `every ${weeklyStartDay}`;
    case cycleTypeEnum.MONTHLY:
      return `on ${monthlyStartDate}${ordinalForStartDate} of every month`;
    case cycleTypeEnum.DAILY:
      return 'every day';
    default:
      return ` - `;
  }
};

export const getValueForKey = (array, key) => {
  for (let i = 0; i < array.length; i += 1) {
    if (array[i].key === key) {
      if (
        key !== billQuestionKey &&
        array[i].value !== undefined &&
        (array[i].value.length > 15 || array[i].value.split(',').length > 1)
      ) {
        return (
          <Tooltip
            position='top'
            showTooltip
            label={formatMultiSelectAnswers(array[i].value, ',')}
            className='tooltipInfo'
            appearance='light'
            size='small'
            style={{
              marginRight: '10px',
              fontSize: '12px',
              borderRadius: '10px',
              width: '250px',
            }}
          >
            {' '}
            {array[i].value.split(',').length > 1 ? (
              <div
                style={{
                  borderBottom: '1px dashed #999',
                  textDecoration: 'none',
                }}
              >
                {' '}
                {`${array[i].value.split(',').length} selected`}
                {' '}
              </div>
            ) : (
              truncateUptoNDigits(array[i].value, 15)
            )}
          </Tooltip>
        );
      }
      return array[i].value;
    }
  }
  return ' - ';
};

export const formatMultiSelectAnswers = (answer, delimiter) => {
  if (!answer || answer === undefined) return ' - ';
  const ansArray = answer.split(',');
  let formattedAnswer = '';
  for (let i = 0; i < ansArray.length - 1; i += 1) {
    formattedAnswer += `${ansArray[i]}${delimiter} `;
  }
  formattedAnswer += ansArray[ansArray.length - 1];
  return formattedAnswer;
};

export const capitalizeFirstLetter = str => {
  if (str.length === 0) {
    return ' ';
  }
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const formatQuestionsColumn = quesHead => {
  const strArr = quesHead.split(' ');
  if (strArr.length === 0) {
    return ' ';
  }
  const shouldAppendEllipsis = strArr.length > 5;
  const limitedWords = strArr.slice(0, 5);
  limitedWords[0] = capitalizeFirstLetter(limitedWords[0]);
  for (let i = 1; i < limitedWords.length; i += 1) {
    if (limitedWords[i] !== limitedWords[i].toUpperCase()) {
      limitedWords[i] = limitedWords[i].toLowerCase();
    }
    if (limitedWords[i].toLowerCase() === 'india') {
      limitedWords[i] = 'India';
    }
  }
  return limitedWords.join(' ') + (shouldAppendEllipsis ? '...' : '');
};

export const getCurrentDateTime = () => {
  const currentDate = new Date();
  return `${currentDate
    .toLocaleDateString()
    .split('/')
    .join('-')} ${currentDate.toLocaleTimeString()}`;
};

export const isConnectedToStagging = () => {
  const cookies = document.cookie.split(';');
  if (cookies.length === 0) {
    return false;
  }
  for (let i = 0; i < cookies.length; i += 1) {
    if (cookies[i].split('=')[0].trim() === FORCESERVER) {
      return true;
    }
  }
  return false;
};

export const payOnlineInvoice = invoice => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  if (
    invoice.status !== invoicesStatusEnum.PAID &&
    invoice.status !== invoicesStatusEnum.PAYMENT_PENDING &&
    invoice.status !== invoicesStatusEnum.PREPAYMENT_PENDING &&
    invoice.status !== invoicesStatusEnum.SETTLED_PAID &&
    invoice.status !== invoicesStatusEnum.KAM_APPROVAL_PENDING
  ) {
    return (
      <div style={{ marginLeft: '15px' }}>
        <InvoiceOnlineContainer onClick={() => setIsModalVisible(true)}>
          Pay now
        </InvoiceOnlineContainer>
        {isModalVisible && (
          <OnlinePaymentModal
            isInvoiceSelected
            invoice={invoice}
            closeModal={() => setIsModalVisible(false)}
            heading='Pay online'
          />
        )}
      </div>
    );
  }
  return <div> </div>;
};

export const filterCurrentData = (val, currentFilters) => {
  let flag = false;
  currentFilters.forEach(filter => {
    for (let i = 0; i < filter.value.length; i += 1)
      if (val.status === filter.value[i]) flag = true;
  });
  return flag;
};

export const zipFiles = async (fileLinks, zipFileName) => {
  const zip = new JSZip();
  const fetchFile = async ({ url, mimeType }) => {
    try {
      const response = await fetch(url, {
        mode: 'cors',
        headers: {
          'Content-Type': mimeType,
        },
      });
      console.log(response);
      if (!response.ok)
        throw new Error(`Failed to fetch ${url}: ${response.statusText}`);
      const blob = await response.blob();
      return new Blob([blob], { type: mimeType }); // Ensure the correct MIME type
    } catch (error) {
      console.error('Fetch error:', error);
      return null;
    }
  };
  for (let i = 0; i < fileLinks.length; i += 1) {
    const fileBlob = fetchFile(fileLinks[i]);
    if (!fileBlob) {
      console.error(`Skipping file due to fetch error: ${fileLinks[i].url}`);
    }
    zip.file(fileLinks[i].name, fileBlob, { binary: true });
  }

  zip
    .generateAsync({ type: 'blob' })
    .then(content => {
      saveAs(content, zipFileName);
    })
    .catch(error => {
      console.error('Error generating ZIP:', error);
      // error toast
    });
};

export const downloadOrderInvoiceZip = async (month, filePath) => {
  const response = await fetch(filePath);
  const blob = await response.blob();
  const fileName = `${orderInvoicesZipFileName} - ${month}.zip`;

  const link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.setAttribute('download', fileName);

  document.body.appendChild(link);
  link.click();

  link.parentNode.removeChild(link);
};

export const formatPaymentRequestStatusEnumForFilter = status => {
  return status + 100;
};

export const employeeTableValueForFlowType = (data, ppiValue, limitValue) => {
  if (data.limit_group_id !== '') {
    return limitValue !== '' ? limitValue : ' - ';
  }
  return ppiValue !== '' ? ppiValue : ' - ';
};

export const clearCookie = async cookieName => {
  document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

export const getUUID = () => {
  // Use crypto.randomUUID if available (modern browsers)
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }

  // Fallback to UUID v4 polyfill
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = Math.floor(Math.random() * 16);
    const v = c === 'x' ? r : (r % 4) + 8;
    return v.toString(16);
  });
};

export const getCycleType = cycleType => {
  switch (cycleType) {
    case cycleTypeEnum.WEEKLY:
      return WEEK;
    case cycleTypeEnum.MONTHLY:
      return MONTH;
    case cycleTypeEnum.DAILY:
      return DAY;
    default:
      return ' - ';
  }
};

export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const phoneNumberRegex = /^([0]|\+91)?[6789]\d{9}$/;
export const numericRegex = /^\d+$/;
export const validateNameRegex = /^[a-zA-Z0-9 ()@-]+$/;
export const getTimeIn12HRFormatRegex = /^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/;
export const URL_PATH_REGEX = /^(\w+\/)*\w+$/;

export const getBrowserAndVersion = () => {
  const userAgent = navigator?.userAgent || '';
  let browserName = 'Unknown';
  let browserVersion = 'Unknown';

  // Detect Browser and Version
  if (userAgent.includes('Firefox')) {
    browserName = 'Firefox';
    [, browserVersion] = userAgent.match(/Firefox\/(\d+\.\d+)/) || [];
  } else if (userAgent.includes('SamsungBrowser')) {
    browserName = 'Samsung Internet';
    [, browserVersion] = userAgent.match(/SamsungBrowser\/(\d+\.\d+)/) || [];
  } else if (userAgent.includes('Opera') || userAgent.includes('OPR')) {
    browserName = 'Opera';
    [, , browserVersion] = userAgent.match(/(Opera|OPR)\/(\d+\.\d+)/) || [];
  } else if (userAgent.includes('Trident')) {
    browserName = 'Internet Explorer';
    [, browserVersion] = userAgent.match(/rv:(\d+\.\d+)/) || [];
  } else if (userAgent.includes('Edge')) {
    browserName = 'Edge';
    [, browserVersion] = userAgent.match(/Edge\/(\d+\.\d+)/) || [];
  } else if (userAgent.includes('Chrome') && !userAgent.includes('CriOS')) {
    browserName = 'Chrome';
    [, browserVersion] = userAgent.match(/Chrome\/(\d+\.\d+)/) || [];
  } else if (
    userAgent.includes('Safari') &&
    !userAgent.includes('Chrome') &&
    !userAgent.includes('CriOS')
  ) {
    browserName = 'Safari';
    [, browserVersion] = userAgent.match(/Version\/(\d+\.\d+)/) || [];
  } else if (userAgent.includes('CriOS')) {
    browserName = 'Chrome for iOS';
    [, browserVersion] = userAgent.match(/CriOS\/(\d+\.\d+)/) || [];
  } else if (userAgent.includes('UCBrowser')) {
    browserName = 'UC Browser';
    [, browserVersion] = userAgent.match(/UCBrowser\/(\d+\.\d+)/) || [];
  }

  return {
    browserName,
    browserVersion,
  };
};

export const formatDateInYYYYMMDD = date => {
  const year = date.toLocaleString('default', {
    year: 'numeric',
  });
  const month = date.toLocaleString('default', {
    month: '2-digit',
  });
  const day = date.toLocaleString('default', {
    day: '2-digit',
  });
  return `${year}-${month}-${day}`;
};

export const sha1Encode = async message => {
  if (typeof crypto !== 'undefined' && crypto.subtle) {
    try {
      const msgBuffer = new TextEncoder().encode(message);
      const hashBuffer = await crypto.subtle.digest('SHA-1', msgBuffer);
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      const hashHex = hashArray
        .map(b => b.toString(16).padStart(2, '0'))
        .join('');
      return hashHex;
    } catch (error) {
      console.warn('crypto.subtle.digest failed, using fallback:', error);
    }
  }

  // Fallback: Simple hash for environments without crypto.subtle
  // This is not secure but works for non-security-critical hashing
  let hash = 0;
  for (let i = 0; i < message.length; i += 1) {
    const char = message.charCodeAt(i);
    // eslint-disable-next-line no-bitwise
    hash = (hash << 5) - hash + char;
    // eslint-disable-next-line no-bitwise
    hash &= hash;
  }
  return Math.abs(hash)
    .toString(16)
    .padStart(10, '0');
};

// Decrypt function for data encrypted with Go's AES-GCM
async function decryptWithSalt(encryptedData, passphrase) {
  try {
    // Decode from base64
    const decodedData = new Uint8Array(
      atob(encryptedData.replace(/-/g, '+').replace(/_/g, '/'))
        .split('')
        .map(char => char.charCodeAt(0)),
    );

    // Import the key
    const keyData = new TextEncoder().encode(passphrase);
    const key = await crypto.subtle.importKey(
      'raw',
      keyData,
      { name: 'AES-GCM' },
      false,
      ['decrypt'],
    );

    // Extract nonce (first 12 bytes for GCM)
    const nonceSize = 12;
    const nonce = decodedData.slice(0, nonceSize);
    const ciphertext = decodedData.slice(nonceSize);

    // Decrypt
    const decryptedBuffer = await crypto.subtle.decrypt(
      {
        name: 'AES-GCM',
        iv: nonce,
      },
      key,
      ciphertext,
    );

    // Convert back to string
    const decryptedText = new TextDecoder().decode(decryptedBuffer);
    return decryptedText;
  } catch (error) {
    console.error('Decryption failed:', error);
    throw new Error('Failed to decrypt data');
  }
}

export const decryptData = async (encryptedPayload, passphrase) => {
  try {
    const decryptedData = await decryptWithSalt(encryptedPayload, passphrase);
    const parsedData = JSON.parse(decryptedData); // If the original data was JSON
    return parsedData;
  } catch (error) {
    console.error('Error decrypting gift card data:', error);
    return null;
  }
};

export const getEntityName = entity => {
  switch (entity) {
    case entityTypeEnum.BLINKIT_USER:
      return 'Blinkit';
    case entityTypeEnum.ZOMATO_USER:
      return 'Zomato';
    case entityTypeEnum.DISTRICT_USER:
      return 'District';
    default:
      return 'Unknown';
  }
};

export const getEntityColor = entity => {
  switch (entity) {
    case entityTypeEnum.BLINKIT_USER:
      return '#F8CB46';
    case entityTypeEnum.ZOMATO_USER:
      return '#E23744';
    case entityTypeEnum.DISTRICT_USER:
      return '#6444E4';
    default:
      return '#000000';
  }
};
